import { render } from "./TableSelectInfo.vue?vue&type=template&id=3337c153"
import script from "./TableSelectInfo.vue?vue&type=script&lang=js"
export * from "./TableSelectInfo.vue?vue&type=script&lang=js"
script.render = render

export default script